import './Open.css'

import TextMove from './TextMove'
import Loader from './Loader';


function OpeningUI() {
  return (
    <div className="app-container">
      {/* <div className="road"> */}
      <div className='ds'>
  
        <div>
          <div className="loader"></div>
        </div>
      </div>
      
      <TextMove />

    </div>
  )
}
export default OpeningUI;
